/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';

import { BuilderSharedModule } from '@gh/builder-shared';

import { EmailRecipientListComponent } from '../email-recipients/components/email-recipient-list/email-recipient-list.component';
import { BuilderSetupEmailRecipientsRoutingModule } from './builder-setup-email-recipients-routing.module';
import { EmailRecipientListBusinessService } from './components/resources/email-recipient-list-business.service';

@NgModule({
  imports: [
    BuilderSharedModule.forChild(),
    BuilderSetupEmailRecipientsRoutingModule,
  ],
  providers: [
    EmailRecipientListBusinessService,
  ],
  declarations: [
    EmailRecipientListComponent,
  ],
})
export class BuilderSetupEmailRecipientsModule {
}
